import { render, staticRenderFns } from "./ConfigParamsHeader.vue?vue&type=template&id=fdac4a9e&"
import script from "./ConfigParamsHeader.vue?vue&type=script&lang=js&"
export * from "./ConfigParamsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdac4a9e')) {
      api.createRecord('fdac4a9e', component.options)
    } else {
      api.reload('fdac4a9e', component.options)
    }
    module.hot.accept("./ConfigParamsHeader.vue?vue&type=template&id=fdac4a9e&", function () {
      api.rerender('fdac4a9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/componentes/configs/ConfigParamsHeader.vue"
export default component.exports